import _ from 'lodash/lodash';
import filterImage from './filterImage'
import getImage from './imageLoader'
import canvasUtil from './canvasUtil'

import download from './download'

// adds floodFill to canvas 2D drawing context
//require('./floodFill');

import fillContext from './floodFill';

// include the spray stamp
const sprayImageSrc = require('../assets/spray.png');
const hashtagImageSrc = require('../assets/hashtag5.png');


const canvasPaint = function (el, state) {

  // canvases
  var canvas = el.querySelector('#paintcanvas');
  canvas.setAttribute('touch-action', 'none');
  var ctx = canvas.getContext('2d');
  var tmp_canvas;
  var tmp_ctx;
  var hint_canvas;
  var hint_ctx;
  var overlay_canvas;
  var overlay_ctx;
  var select_canvas;
  var select_ctx;
  var stamp_canvas;
  var stamp_ctx;
  var empty_canv;
  var sprayIntervalID;
  var round_coords = true;
  var grid_sizes = [0, 4, 8, 16];
  var draggables;

  // undo
  var undo_arr, undo_count;

  var pointers = [];

  var stampImage, pencilImage, hashTagImage;

  // paint tool drawing handlers
  var tools = {
    pencil: onPaintStamp,
    brush: onPaintStamp,
    circle: onPaintCircle,
    circlefill: onPaintCircle,
    line: onPaintLine,
    rect: onPaintRect,
    rectfill: onPaintRect,
    roundrect: onPaintRoundRect,
    roundrectfill: onPaintRoundRect,
    oval: onPaintEllipse,
    ovalfill: onPaintEllipse,
    eraser: onPaintStamp,
    //spray: generateSprayParticles, // fancy spraypaint
    spray: onSpray, // old-skool spray paint
    move: onMove,
    bucket: noop,
    triangle: noop,
    triangleFill: noop,
    select: onDrawSelect
  };

  initCanvii();
  initStamps();
  reset();
  initListeners();

  function initCanvii() {
    tmp_canvas = document.createElement('canvas');
    hint_canvas = document.createElement('canvas');
    select_canvas = document.createElement('canvas');
    overlay_canvas = document.createElement('canvas');
    tmp_canvas.setAttribute('touch-action', 'none');
    tmp_ctx = tmp_canvas.getContext('2d');
    hint_ctx = hint_canvas.getContext('2d');
    select_ctx = select_canvas.getContext('2d');
    overlay_ctx = overlay_canvas.getContext('2d');
    select_canvas.id = 'select_canvas';
    select_canvas.setAttribute('touch-action', 'none');
    tmp_canvas.id = 'tmp_canvas';
    overlay_canvas.width = hint_canvas.width = tmp_canvas.width = canvas.width;
    overlay_canvas.height = hint_canvas.height = tmp_canvas.height = canvas.height;
    overlay_canvas.id = 'overlay_canvas';
    hint_canvas.id = 'hint_canvas';

    canvas.parentNode.appendChild(tmp_canvas);
    canvas.parentNode.appendChild(hint_canvas);
    canvas.parentNode.appendChild(select_canvas);
    canvas.parentNode.appendChild(overlay_canvas);

    stamp_canvas = document.createElement('canvas');
    stamp_canvas.width = 20;
    stamp_canvas.height = 20;
    stamp_ctx = stamp_canvas.getContext('2d');

    ctx.imageSmoothingEnabled = false;
    tmp_ctx.imageSmoothingEnabled = false;

    // start with background color
    ctx.fillStyle = state.backgroundColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  // Init the images or canvases we will use as stamps
  function initStamps() {

    // create a pixel image to use as a pencil stamp
    pencilImage = document.createElement('canvas');
    pencilImage.width = 1;
    pencilImage.height = 1;
    pencilImage.getContext('2d').fillRect(0, 0, 1, 1);


    // load spray paint stamp as image (webpack will bundle this)
    getImage(sprayImageSrc).then((img)=> {
      // draw image to canvas
      stampImage = document.createElement('canvas');
      stampImage.width = stampImage.height = 20;
      stampImage.getContext('2d').drawImage(img, 0, 0, 20, 20);
    });

    getImage(hashtagImageSrc).then((img)=> {
      hashTagImage = img;
      // // draw image to canvas
      // hashTagImage = document.createElement('canvas');
      // hashTagImage.width = img.width;
      // hashTagImage.height = img.height;
      // hashTagImage.getContext('2d').drawImage(img, 0, 0);
    });

  }

  function initListeners() {
    tmp_canvas.addEventListener('pointerdown', startDrawing, false);
    document.addEventListener('pointercancel', stopDrawing);
    select_canvas.addEventListener('pointerdown', startDraggingSelection, false);
  }

  function noop() {}

  function reset(fill=true) {
    state.undoEnabled = false;
    state.readyForSave = false;

    stopDrawing();
    ctx.save();
    if(fill) {
      ctx.fillStyle = state.backgroundColor;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    overlay_ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
    undo_arr = [];
    pointers = [];
    undo_count = 0;
    empty_canv = canvas.toDataURL();
    undo_arr.push(empty_canv);

    // reset move coordinates
    var container = $(canvas).parent().parent();
    container[0].scrollLeft = 0;
    container[0].scrollTop = 29; //141;
    $(select_canvas).hide();
  }

  function startDrawing(e) {

    // Don't draw more than one line at a time.. not quite ready for multi-touch.
    if (state.drawing) return;

    state.drawing = true;
    state.readyForSave = true;

    tmp_canvas.addEventListener('pointermove', onPaint, false);
    document.addEventListener('pointerup', stopDrawing, false);

    var pointer = pointers[e.pointerId] = {
      current: {x: 0, y: 0},
      start: {x: 0, y: 0}
    };

    updatePointer(e);

    pointer.start.x = pointer.current.x;
    pointer.start.y = pointer.current.y;
    pointer.path = [_.clone(pointer.current)];

    //spraying tool.
    clearInterval(sprayIntervalID);
    if (state.tool == 'spray') {

      // paint even when mouse is not moving?
      // MS paint did not
      //sprayIntervalID = setInterval(onPaint, 100);
    }

    onPaint(e);
  }

  function stopDrawing(e) {

    if (e && e.target == tmp_canvas) {
      // pointer up on drawing (complete shape)
      completePainting(updatePointer(e));
    } else {
      cancelPainting(updatePointer(e));
    }

    if (e && e.pointerId && pointers[e.pointerId]) {
      delete pointers[e.pointerId];
      // console.log('Stopped drawing.');
      // console.log('pointers', pointers);
    }

    if (!state.drawing) return;

    state.drawing = false;

    tmp_canvas.removeEventListener('pointermove', onPaint, false);
    document.removeEventListener('pointerup', stopDrawing, false);

    //console.log('stop drawing');

    if(state.tool!='select') {
      pushUndoState();
    }
  }

  var previous_ctx, redo_ctx;

  function pushUndoState() {

    //console.log('pushing undo state');

    // save previous state
    previous_ctx = previous_ctx || document.createElement('canvas').getContext('2d');
    redo_ctx = redo_ctx || document.createElement('canvas').getContext('2d');
    redo_ctx.canvas.width = previous_ctx.canvas.width = canvas.width;
    redo_ctx.canvas.height = previous_ctx.canvas.height = canvas.height;

    previous_ctx.fillStyle = state.backgroundColor;
    previous_ctx.fillRect(0, 0, canvas.width, canvas.height);
    previous_ctx.drawImage(canvas, 0, 0);

    // Writing down to real canvas now
    ctx.drawImage(tmp_canvas, 0, 0);

    redo_ctx.fillStyle = state.backgroundColor;
    redo_ctx.fillRect(0, 0, canvas.width, canvas.height);
    redo_ctx.drawImage(canvas, 0, 0);

    state.undoEnabled = true;

    // filter the main ctx (keep it pixelated)
    filterImage(ctx);

    // Clearing tmp canvas
    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);

    // undo_arr.push(canvas.toDataURL());
    // undo_count = 0;


  }

  // capture mouse loc from pointer event
  function updatePointer(e) {

    if (e) {

      var pointer = pointers[e.pointerId];

      if (!pointer) {
        return null;
      }

      var mouse = {};
      var offset = $(e.target).offset();
      var rect = e.target.getBoundingClientRect();

      // If there is no current pointer,
      // reference the new 'current' pointer as the last
      // distance calcs should come to zero
      pointer.last = pointer.current || mouse;

      // assume we are drawing on canvas that has been scaled with a CSS Transform
      mouse.scale = rect.width / canvas.width;

      mouse.x = (e.pageX - offset.left) / mouse.scale;
      mouse.y = (e.pageY - offset.top) / mouse.scale;

      if (state.grid && toolUsesGrid(state.tool)) {
        var gridSize = grid_sizes[state.grid];
        mouse.x = Math.round(mouse.x / gridSize) * gridSize;
        mouse.y = Math.round(mouse.y / gridSize) * gridSize;
      }

      if (round_coords) {
        mouse.x = mouse.x >> 0;
        mouse.y = mouse.y >> 0;
      }

      pointer.current = mouse;

      pointer.distance = distance(pointer.last, pointer.current);

      // distance from start
      if (pointer.start) {
        pointer.distanceFromStart = distance(pointer.start, pointer.current);
      }

      return pointer;

    } else {
      return null;
    }
  }

  // Don't use grid for move tool or eraser
  function toolUsesGrid(tool) {
    switch (tool) {
      case 'move':
      case 'erase':
        return false;
      default:
        return true;
    }
  }

  // pointer moved
  function onPaint(e) {

    const paint_func = tools[state.tool] || tools.brush;
    const pointer = updatePointer(e);

    if (pointer) {

      tmp_ctx.strokeStyle = state.color;
      tmp_ctx.fillStyle = state.color;
      tmp_ctx.lineWidth = state.tool == 'pencil' ? 1.0 : state.lineWidth;
      tmp_ctx.lineJoin = 'round';
      tmp_ctx.lineCap = 'round';

      // call the paint function
      paint_func(pointer);

      // filter the image
      filterImage(tmp_ctx);
    }

  }

  // On pointer Up, some tools need to complete a final step
  function completePainting(pointer) {
    switch (state.tool) {
      case 'blob':
      case 'blobfill':

        // draw a line from start to end
        var stamp = pencilImage;
        drawLineWithStamp(tmp_ctx, pencilImage, pointer.start, pointer.current, 1);
        colorizeActiveDrawing();
        // var d = pointer.distanceFromStart;
        // var inc = 1;
        // for (var i = 0; i < d; i += inc) {
        //   var p = pointAlongLine(pointer.start, pointer.current, i / d);
        //   paintWithStamp(tmp_ctx, stamp, p, 1);
        // }

        var do_fill = state.tool.indexOf('fill') != -1;
        var pencil_stroke = (state.lineWidth == 1 && !do_fill);


        // fill blob
        var ctx = tmp_ctx;

        // clear the pencil line if we aren't using it as the stroke
        if (!pencil_stroke) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(pointer.start.x, pointer.start.y);
        _.each(pointer.path, function (p) {
          ctx.lineTo(p.x, p.y);
        });
        ctx.lineTo(pointer.start.x, pointer.start.y);

        if (state.tool.indexOf('fill') != -1) {
          ctx.fill();
        }

        if (!pencil_stroke) {
          ctx.stroke();
        }
        ctx.restore();
        break;

      case 'select':
        initSelection(pointer);
        break;

      case 'bucket':
        onBucketFill(pointer);
        break;
    }
    filterImage(tmp_ctx);
  }


  // draw selection rect on hint layer as it is being selected
  function onDrawSelect(pointer) {

    //console.log('onDrawSelect');

    // clear select listeners
    stopDraggingSelection();

    $(select_canvas).hide();

    const mouse = pointer.current;
    const start_mouse = pointer.start;

    // paint to hint canvas instead of temp
    hint_ctx.clearRect(0, 0, hint_canvas.width, hint_canvas.height);

    // override line join
    hint_ctx.lineJoin = 'miter';
    hint_ctx.setLineDash([2,4]);

    var x = Math.min(mouse.x, start_mouse.x) + 0.5;
    var y = Math.min(mouse.y, start_mouse.y) + 0.5;
    var width = Math.abs(mouse.x - start_mouse.x);
    var height = Math.abs(mouse.y - start_mouse.y);

    hint_ctx.strokeWidth = .5;
    hint_ctx.strokeRect(x, y, width, height);
  }


  var dragStart = {x: 0, y: 0};
  var dragLoc = null;
  var selectLoc = {x: 0, y: 0};
  var dragOffset = {x: 0, y: 0};
  var dragging = false;
  var hasSelection = false;
  var selectionMoved = false;

  // create the selection rect as a floating overlay canvas
  function initSelection(pointer) {

    //console.log('init selection');

    const mouse = pointer.current;
    const start = pointer.start;

    // draw selected area to it's own canvas
    var x = Math.min(mouse.x, start.x) >> 0;
    var y = Math.min(mouse.y, start.y) >> 0;
    var width = Math.abs(mouse.x - start.x) >> 0;
    var height = Math.abs(mouse.y - start.y) >> 0;

    // hide the hint rect
    hint_ctx.clearRect(0, 0, hint_canvas.width, hint_canvas.height);

    // clear selection
    if(width<16 && height<16) {
      clearSelection();
      return;
    }

    // draw the current canvas to the fill rect
    select_canvas.width = width;
    select_canvas.height = height;
    select_ctx.fillStyle = state.backgroundColor;
    select_ctx.fillRect(0, 0, width, height);
    select_ctx.drawImage(canvas, x, y, width, height, 0, 0, width, height);


    if(!hasSelection) {
      // first  time, draw canvas to the tmp ctx
      console.log('no selection yet, making sure tmp_ctx has latest canvas');
      tmp_ctx.fillStyle = '#ff0000';
      tmp_ctx.fillRect(0, 0, canvas.width, canvas.height);
      tmp_ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height);
    }


    // put it on top and make it draggable
    $(select_canvas).show();

    selectLoc.x = x;
    selectLoc.y = y;

    // position the canvas overlay
    TweenLite.set(select_canvas, {
      x: x,
      y: y
    });

    // draw white square on tmp canvas
    tmp_ctx.fillStyle = state.backgroundColor;
    tmp_ctx.fillRect(selectLoc.x, selectLoc.y, select_canvas.width, select_canvas.height);

    hasSelection = true;
    selectionMoved = false;
  }

  function clearSelection() {
    //console.log('clear selection');
    if(hasSelection) {
      applySelection();
    }
    hasSelection = false;
    selectionMoved = false;
    dragging = false;
    stopDraggingSelection();
    $(select_canvas).hide();
  }

  // Paste selection onto the background
  function applySelection() {

    // paint it to the canvas below
    tmp_ctx.drawImage(select_canvas, selectLoc.x>>0, selectLoc.y>>0, select_canvas.width, select_canvas.height);

    //if(selectionMoved) {
      pushUndoState();
    //}
  }

  // pointer down
  function startDraggingSelection(e) {

    var offset = $(canvas).offset();
    var rect = canvas.getBoundingClientRect();

    // reset previous dragLoc
    dragLoc = null;

    dragStart.scale = rect.width / canvas.width;
    dragStart.x = (e.pageX - offset.left) / dragStart.scale;
    dragStart.y = (e.pageY - offset.top) / dragStart.scale;

    dragOffset.x = dragStart.x - ($(select_canvas).offset().left / dragStart.scale);
    dragOffset.y = dragStart.y - ($(select_canvas).offset().top / dragStart.scale);

    console.log('drag start', dragStart, dragOffset);

    $(canvas).parent().addClass('dragging');

    tmp_canvas.addEventListener('pointermove', onDragSelection, false);
    document.addEventListener('pointerup', stopDraggingSelection, false);
  }

  // pointer move
  function onDragSelection(e) {

    selectionMoved = true;
    dragging = true;

    var mouse = {};
    var offset = $(canvas).offset();
    var rect = canvas.getBoundingClientRect();

    mouse.scale = rect.width / canvas.width;
    mouse.x = (e.pageX - offset.left) / mouse.scale;
    mouse.y = (e.pageY - offset.top) / mouse.scale;

    var prev = dragLoc || dragStart;

    selectLoc.x += mouse.x - prev.x;
    selectLoc.y += mouse.y - prev.y;

    TweenLite.set(select_canvas, {
      x: selectLoc.x,
      y: selectLoc.y,
      z: -1  // Chrome bugfix - weirdness
    });

    // save last loc
    dragLoc = mouse;

  }

  // pointer up
  function stopDraggingSelection(e) {
    //console.log('stop dragging');

    if (e && dragging) {
      // came from a pointer event
    }

    dragging = false;
    $(canvas).parent().removeClass('dragging');

    tmp_canvas.removeEventListener('pointermove', onDragSelection, false);
    document.removeEventListener('pointerup', stopDraggingSelection, false);
  }

  // Cancel current paint gesture
  // (if we got a pointer up off canvas, don't complete blobs)
  function cancelPainting(pointer) {
    switch (state.tool) {
      case 'blob':
      case 'blobfill':
        tmp_ctx.clearRect(0, 0, canvas.width, canvas.height);
        break;
    }
  }

  function onPaintCircle(pointer) {

    const mouse = pointer.current;
    const start_mouse = pointer.start;

    // Tmp canvas is always cleared up before drawing.
    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);

    var x = (mouse.x + start_mouse.x) / 2;
    var y = (mouse.y + start_mouse.y) / 2;

    var radius = Math.max(
        Math.abs(mouse.x - start_mouse.x),
        Math.abs(mouse.y - start_mouse.y)
      ) / 2;

    tmp_ctx.beginPath();
    tmp_ctx.arc((x >> 0) + .5, (y >> 0) + .5, radius >> 0, 0, Math.PI * 2, false);
    tmp_ctx.stroke();
    if (state.tool.indexOf('fill') != -1) {
      tmp_ctx.fill();
    }
    tmp_ctx.closePath();

  }

  function onPaintLine(pointer) {

    const mouse = pointer.current;
    const start_mouse = pointer.start;

    // override line cap
    tmp_ctx.lineCap = 'square';

    // temp canvas is always cleared up before drawing.
    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);

    // switch(state.lineWidth) {
    //   case 1:
    //     paintLineWithStamp(tmp_ctx, pencilImage, start_mouse, mouse);
    //     break;
    //
    //   default:
    tmp_ctx.beginPath();
    tmp_ctx.moveTo(start_mouse.x, start_mouse.y);
    tmp_ctx.lineTo(mouse.x, mouse.y);
    tmp_ctx.stroke();
    tmp_ctx.closePath();
    //}

  }

  function onPaintRect(pointer) {

    const mouse = pointer.current;
    const start_mouse = pointer.start;

    // Tmp canvas is always cleared up before drawing.
    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);

    // override line join
    tmp_ctx.lineJoin = 'miter';

    var x = Math.min(mouse.x, start_mouse.x) + 0.5;
    var y = Math.min(mouse.y, start_mouse.y) + 0.5;
    var width = Math.abs(mouse.x - start_mouse.x);
    var height = Math.abs(mouse.y - start_mouse.y);
    if (state.tool.indexOf('fill') != -1) {
      tmp_ctx.fillRect(x, y, width, height);
    }
    tmp_ctx.strokeRect(x, y, width, height);

    //console.log(tmp_ctx.lineWidth, x, y);

  }

  function onPaintRoundRect(pointer) {
    const mouse = pointer.current;
    const start_mouse = pointer.start;

    // Tmp canvas is always cleared up before drawing.
    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);

    // override line join
    //tmp_ctx.lineJoin = 'miter';

    var x = Math.min(mouse.x, start_mouse.x) + 0.5;
    var y = Math.min(mouse.y, start_mouse.y) + 0.5;
    var width = Math.abs(mouse.x - start_mouse.x);
    var height = Math.abs(mouse.y - start_mouse.y);
    var corner_radius = Math.min(9, width / 2, height / 2);
    canvasUtil.drawRoundRect(tmp_ctx, x, y, width, height, corner_radius, state.tool.indexOf('fill') != -1, true);
  }

  function onPaintEllipse(pointer) {

    const mouse = pointer.current;
    const start_mouse = pointer.start;

    tmp_ctx.clearRect(0, 0, tmp_canvas.width, tmp_canvas.height);

    var x = Math.min(mouse.x, start_mouse.x);
    var y = Math.min(mouse.y, start_mouse.y);

    var w = Math.abs(mouse.x - start_mouse.x);
    var h = Math.abs(mouse.y - start_mouse.y);

    var kappa = .5522848,
      ox = (w / 2) * kappa, // control point offset horizontal
      oy = (h / 2) * kappa, // control point offset vertical
      xe = x + w,           // x-end
      ye = y + h,           // y-end
      xm = x + w / 2,       // x-middle
      ym = y + h / 2;       // y-middle

    tmp_ctx.beginPath();
    tmp_ctx.moveTo(x, ym);
    tmp_ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
    tmp_ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
    tmp_ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
    tmp_ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
    tmp_ctx.closePath();
    tmp_ctx.stroke();
    if (state.tool.indexOf('fill') != -1) {
      tmp_ctx.fill();
    }
  }

  function onMove(pointer) {
    var container = $(canvas).parent().parent();
    container[0].scrollLeft += pointer.start.x - pointer.current.x;
    container[0].scrollTop += pointer.start.y - pointer.current.y;
  }

  function onSpray(pointer) {
    paintWithStamp(tmp_ctx, stampImage, pointer.current, 20);
    colorizeActiveDrawing();
  }

  // new vintage-style paint handler for the paintbrush tool
  function onPaintStamp(pointer) {

    pointer.path.push(pointer.current);

    // paint with the stamp like we do for spray paint
    // but complete lines from start to finish

    let stamp, size = 20;

    switch (state.tool) {

      // use the pencil stamp for drawing with the pencil
      // and the free-form blob tools
      case 'pencil':
      case 'blob':
      case 'blobfill':
        stamp = pencilImage;
        size = 1;
        break;

      // Use the eraser stamp for erasing
      // and fill with background color
      case 'eraser':
        stamp = state.getEraserBrushStamp();
        tmp_ctx.fillStyle = state.backgroundColor;
        break;
      default:
        stamp = state.getSelectedBrushStamp();
    }

    paintWithStamp(tmp_ctx, stamp, pointer.current, size);
    drawLineWithStamp(tmp_ctx, stamp, pointer.last, pointer.current, size);
    colorizeActiveDrawing();
  }

  // start and end are point objects with x and y properties
  // t is normalized distance, 0 - 1.0
  function pointAlongLine(start, end, t) {
    return {
      x: start.x + (end.x - start.x) * t,
      y: start.y + (end.y - start.y) * t
    };
  }

  // draw a line from one point to another using a stamp image
  function drawLineWithStamp(ctx, stamp, start, end, size = 20) {
    var inc = 1;
    var d = distance(start, end);
    for (var i = 0; i < d; i += inc) {
      var p = pointAlongLine(start, end, i / d);
      paintWithStamp(ctx, stamp, p, size);
    }
  }

  // distance calc
  function distance(start, end) {
    let dx = end.x - start.x;
    let dy = end.y - start.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  // center stamp over cursor and draw it
  // stamp should be square 20x20
  function paintWithStamp(ctx, img, loc, size = 20) {
    // draw stamp canvas (colored stamp) to main display
    ctx.save();
    ctx.translate(loc.x - size / 2, loc.y - size / 2);
    ctx.drawImage(img, 0, 0, size, size);
    ctx.restore();
  }

  function colorizeActiveDrawing() {
    tmp_ctx.globalCompositeOperation = 'source-in';
    tmp_ctx.fillRect(0, 0, canvas.width, canvas.height);
    tmp_ctx.globalCompositeOperation = 'source-over';
  }

  function onBucketFill(pointer) {
    tmp_ctx.save();
    tmp_ctx.fillStyle = state.backgroundColor;
    tmp_ctx.fillRect(0, 0, canvas.width, canvas.height);
    tmp_ctx.restore();
    tmp_ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height);

    //tmp_ctx.fillFlood(pointer.current.x, pointer.current.y, 2);
    var image = tmp_ctx.getImageData(0,0,canvas.width, canvas.height);
    var data = image.data;

    var tolerance = 0;
    fillContext(tmp_ctx, state.color, Math.floor(pointer.current.x), Math.floor(pointer.current.y), tolerance, 0, 0, canvas.width, canvas.height);
  }

  // draw undo image on the canvas
  function drawUndo(count) {
    var number = undo_arr.length;
    var img_data = undo_arr[number - (count + 1)];
    var undo_img = new Image();
    undo_img.src = img_data.toString();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(undo_img, 0, 0);
  }

  var self = {

    clear(force = false) {
      //if (force || confirm("Do you really want to erase the canvas?")) {
      reset();
      //}
    },

    destroy() {
      stopDrawing();
      stopDraggingSelection();
      tmp_canvas.removeEventListener('pointerdown', startDrawing, false);
      document.removeEventListener('pointercancel', stopDrawing);
      select_canvas.removeEventListener('pointerdown', startDraggingSelection, false);
    },

    // download canvas as a file
    download(filename = 'download.png') {

      // don't try to download unless we have drawn something
      if(!state.readyForSave) {
        return false;
      }

      // create an "off-screen" anchor tag
      var lnk = document.createElement('a'),
        c = document.createElement('canvas'),
        e;

      var scale = 4;
      c.width = canvas.width * scale;
      c.height = canvas.height * scale;
      var cx = c.getContext('2d');
      cx.mozImageSmoothingEnabled = false;
      cx.webkitImageSmoothingEnabled = false;
      cx.msImageSmoothingEnabled = false;
      cx.imageSmoothingEnabled = false;
      cx.fillStyle = state.backgroundColor;
      cx.fillRect(0, 0, c.width, c.height);
      cx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, c.width, c.height);

      // and draw overlay
      cx.drawImage(overlay_canvas, 0, 0, canvas.width, canvas.height, 0, 0, c.width, c.height);

      // add stamp
      // if(hashTagImage) {
      //   cx.drawImage(hashTagImage, c.width-hashTagImage.width, c.height-hashTagImage.height);
      // }

      // Use cross-platform download script for MS browsers
      if(navigator && navigator.msSaveBlob) {
        download(c.toDataURL(), filename, 'image/png');
        return;
      }

      // Non MS - do original download in popup on iOS


      // the key here is to set the download attribute of the a tag
      lnk.download = filename;

      // convert canvas content to data-uri for link. When download
      // attribute is set the content pointed to by link will be
      // pushed as "download" in HTML5 capable browsers
      lnk.href = c.toDataURL();
      lnk.target = '_blank';

      // create a "fake" click-event to trigger the download
      if (document.createEvent) {

        e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", true, true, window,
          0, 0, 0, 0, 0, false, false, false,
          false, 0, null);

        lnk.dispatchEvent(e);

      } else if (lnk.fireEvent) {

        lnk.fireEvent("onclick");
      }
      return true;
    },

    undo() {
      if(state.undoEnabled) {
        if(previous_ctx) {
          ctx.drawImage(previous_ctx.canvas, 0, 0);
        }
        state.undoEnabled = false;
      } else {
        // redo
        if(redo_ctx) {
          ctx.drawImage( redo_ctx.canvas, 0, 0);
          state.undoEnabled = true;
        }
      }
    },

    // Load image into the editor (actually, just into overlay canvas)
    loadImage(src) {
      reset(false);
      getImage(src).then(img=> {
        var x = (img.width - canvas.width) / 2;
        var y = (img.height - canvas.height) / 2;
        // overlay_ctx.drawImage(img, -x, -y);
        ctx.drawImage(img, -x, -y);

        state.readyForSave = true;
        //
        // // add stamp to overlay?
        // if(hashTagImage) {
        //   overlay_ctx.save();
        //   var scale = .25;
        //   overlay_ctx.translate(canvas.width-hashTagImage.width*scale, canvas.height-hashTagImage.height*scale);
        //   overlay_ctx.scale(scale, scale);
        //   overlay_ctx.drawImage(hashTagImage, 0, 0);
        //   overlay_ctx.restore();
        // }
      });
    },

    onToolChange() {
      clearSelection();
    }

  };

  //console.log('init drawing canvas', self);

  window.paint = self;
  return self;
};

export default canvasPaint;



// WEBPACK FOOTER //
// ./src/util/canvasPaint.js